var $48f3f33a29908d4c$exports = {};
$48f3f33a29908d4c$exports = {
  "close": "U\u017Edaryti",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " prane\u0161imas");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " prane\u0161imai");
      }
    }), ".");
  }
};
export { $48f3f33a29908d4c$exports as default };